<template lang="pug">
  include ./../../mixins
  validation-provider(
    v-slot="{errors}"
    :rules="rules"
    :name="name"
  )
    +b.ma--b_xxs.TEXT-BEMTO(
      v-if="inputLabel"
      :fw="'bold'"
      :lh="'initial'"
      :fs="'1xs'"
      :color="'black'"
      :tag="'p'"
    ) {{ inputLabel }}
    +b.el-selector(
      @click.prevent="toggleListAction"
      @mouseleave="hideListAction"
      v-model="value" :name="name"
      :class="{'el-selector--inactive': !objectList.length}"
    )
      +e.placeholder
        +e.title.TEXT-BEMTO(
          :fw="'medium'"
          :lh="'initial'"
          :fs="'1xs'"
          :tag="'p'"
        ) {{ currentTitle || placeholder }}
        +e.icon.icon--type_dropdown.I
      +e.options(
        v-if="options"
      )
        +e.wrapper.bg--white.margin--t_1xs
          +e.list.UL(
            v-if="objectList.length"
          )
            +e.item.LI(
              v-for="(item, index) in objectList" :key="index"
              @click.prevent="changeValueEvent(item)"
            )
              +b.TEXT-BEMTO(
                :weight="'bold'"
                :height="'xs'"
                :size="'1xs'"
                :tag="'p'"
              ) {{ item.label || item.title || item[Object.keys(item)[0]] }}
          +e.list.UL(
            v-if="!objectList.length"
          )
            +e.item.LI
              +b.TEXT-BEMTO(
                :weight="'bold'"
                :height="'xs'"
                :size="'1xs'"
                :tag="'p'"
              ) {{ _('No data') }}
      +e.errors {{ errors[0] }}
</template>

<script>
export default {
  name: 'ControlOption',
  props: {
    objectList: {
      type: Array,
      required: true,
    },
    inputLabel: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {},
    rules: {
      type: String,
    },
    name: {
      type: String,
    },
  },
  data: () => ({
    options: false,
  }),
  methods: {
    /**
     * Handles change input value
     * @instance
     * @method
     * @param {String} value - current value
     */
    changeValueEvent(value) {
      this.$emit('input', value.id || Object.keys(value)[0])
      this.$emit('change', value.id || Object.keys(value)[0])
    },
    /**
     * Show or hide the list of items.
     * @instance
     * @method
     */
    toggleListAction() {
      this.options = !this.options
    },
    /**
     * Hide list after miss target.
     * @instance
     * @method
     */
    hideListAction() {
      this.options = false
    },
  },
  computed: {
    /**
     * Setting the correct selector header/placeholder.
     * @instance
     * @method
     *
     */
    currentTitle() {
      if (this.value) {
        const result = this.objectList.filter(item => {
          const value = item.id || Object.keys(item)[0]
          return String(value) === String(this.value)
        })

        const TITLE = result[0].label ? result[0].label : result[0].title

        return TITLE|| result[0][Object.keys(result[0])[0]]
      }
      return ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Controls/ControlOption.vue